import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { PositionsTable } from '../../positions-table'
import { reatomWalletPositionsTableModel } from '../atoms'

import type { AggregatedPositionModel } from '@root/entities/position'
import type { DialogControlProps } from '@root/shared/ui-kit'

type WalletPositionsDialogProps = {
  position: AggregatedPositionModel
} & DialogControlProps

export const WalletPositionsDialog: React.FC<WalletPositionsDialogProps> = ({
  position,
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation()
  const model = useMemo(
    () =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomWalletPositionsTableModel({
        position,
      }),
    [position],
  )

  return (
    <Root
      describedBy="wallet-positions-dialog"
      open={open}
      onOpenChange={onOpenChange}
    >
      <Root.Header
        title={t('position.wallet-position-modal.title', {
          ticker: position.pair.quote.ticker,
        })}
      />
      <Content>
        <Table model={model} />
      </Content>
    </Root>
  )
}

const Root = styled(Dialog)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  height: min(90vh, 600px);
  width: min(90vw, 800px);
`

const Content = styled.div`
  display: grid;
  padding: 12px;
`

const Table = styled(PositionsTable)`
  border: 1px solid var(--background-4);
  border-radius: 12px;
  overflow: hidden;
  background: var(--background-1);
`
